<template>
  <div class="alert_bg">
    <div class="alert_body" v-if="false">
      <div class="close_btn" @click="onCancelClick"></div>
      <div class="warn_icon"></div>
      <div class="warn_title">今日体验次数已用完</div>
      <!-- <div
				class="warn_tips"
				v-if="max_services <= $store.state.limit.service.normal"
			>
				<font>您当前可使用</font
				><font class="num">{{ max_services }}</font
				><font>个远程服务，若需使用更多远程服务，请</font
				><font class="speed" @click="onSpeedClick">开启加速模式</font
				><font>或</font
				><font class="vip" @click="onPayClick">开通小宝会员</font>
			</div>
			<div class="warn_tips" v-else>
				<font>您当前可使用</font
				><font class="num">{{ max_services }}</font
				><font>个远程服务，若需使用更多远程服务，请</font
				><font class="vip" @click="onPayClick">开通小宝会员</font>
			</div> -->
      <div class="vip_tips">开通小宝VIP享受不限次数连接</div>
      <div class="btns">
        <div class="pay_btn" @click="onPayClick">开通小宝会员</div>
      </div>
    </div>

    <div class="add-limit-wrap">
      <div class="limit-close" @click="onCancelClick"></div>
      <div class="limit-title">访问超限</div>
      <div class="limit-text">
        当前限每日 <span>{{ $store.state.limit.times.normal }}</span> 次访问
      </div>
      <div class="limit-item">
        <div class="item-text">开通高级会员</div>
        <div class="item-text item-text2">远程随心连接</div>
      </div>
      <div class="limit-item2"></div>
      <div class="limit-item3">
        <div class="item3-text">
          <div class="item3-icon"></div>
          不限访问次数
        </div>
        <div class="item3-text">
          <div class="item3-icon item3-icon2"></div>
          不限设备数量
        </div>
        <div class="item3-text">
          <div class="item3-icon item3-icon3"></div>
          享受高速带宽
        </div>
      </div>
      <div class="limit-btns">
        <div class="btn" @click="onCancelClick">取消</div>
        <div class="btn btn2" @click="goPayClick">立即开通</div>
      </div>
    </div>

    <div class="speed_body" v-if="isShowSpeed">
      <div class="speed_body_wrap">
        <div class="mode_desc_item_wrap">
          <div class="mode_desc_item mode_desc_item_01">
            <div class="mode_desc_item_text">
              <font class="num">4</font><font>个远程服务</font>
            </div>
          </div>
          <div class="mode_desc_item mode_desc_item_02">
            <div class="mode_desc_item_text">支持节点加速</div>
          </div>
          <div class="mode_desc_item mode_desc_item_03">
            <div class="mode_desc_item_text">支持积分奖励</div>
          </div>
        </div>
      </div>
    </div>
    <div class="vip_body" v-if="isShowVip">
      <div class="vip_body_wrap">
        <div class="vip_item_wrap">
          <div class="vip_item vip_item_01">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">高速</div>
            </div>
            <div class="vip_item_title">转发通道速度</div>
          </div>
          <div class="vip_item vip_item_02">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">不限量</div>
            </div>
            <div class="vip_item_title">小宝带宽流量</div>
          </div>
          <div class="vip_item vip_item_03">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">支持</div>
            </div>
            <div class="vip_item_title">自定义映射服务</div>
          </div>
          <div class="vip_item vip_item_04">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">不限次</div>
            </div>
            <div class="vip_item_title">自定义端口映射</div>
          </div>
          <div class="vip_item vip_item_05">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">不限量</div>
            </div>
            <div class="vip_item_title">远程服务数量</div>
          </div>
          <div class="vip_item vip_item_06">
            <div class="vip_item_icon"></div>
            <div class="vip_item_value">
              <div class="vip_item_value_text">
                <font>{{ $store.state.limit.bind.vip }}</font
                >个
              </div>
            </div>
            <div class="vip_item_title">设备绑定数量</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["max_services"],
  data: function () {
    return {
      isShowSpeed: false,
      isShowVip: false,
    };
  },
  methods: {
    ...mapActions(["sendUserlog"]),
    goPayClick: function () {
      this.$router.push("/home/vip");
    },
    showSpeed: function () {
      this.isShowSpeed = true;
    },
    hideSpeed: function () {
      this.isShowSpeed = false;
    },
    showVip: function () {
      this.isShowVip = true;
    },
    hideVip: function () {
      this.isShowVip = false;
    },
    onCancelClick: function () {
      let _that = this;
      _that.sendUserlog(["service_limit_cancel_click", _that.max_services]);
      _that.$emit("onCancelClick");
    },
    onPayClick: function () {
      let _that = this;
      _that.sendUserlog(["service_limit_pay_click", _that.max_services]);
      _that.$emit("onCancelClick");
      _that.$emit("onPayClick");
    },
    onSpeedClick: function () {
      let _that = this;
      _that.sendUserlog(["service_limit_speed_click", _that.max_services]);
      _that.$emit("onCancelClick");
      _that.$emit("onSpeedClick");
    },
  },
  mounted: function () {
    let _that = this;
    _that.sendUserlog(["service_limit", _that.max_services]);
  },
};
</script>

<style lang="less" scoped>
.alert_bg {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(82, 82, 82, 0.36);
  z-index: 9;
  .alert_body {
    width: 340px;
    height: 260px;
    left: 50%;
    top: 50%;
    margin-left: -170px;
    margin-top: -130px;
    background-color: #ffffff;
    background-image: linear-gradient(180deg, #fff9f4, #ffffff);
    position: absolute;
    border-radius: 5px;
    .close_btn {
      width: 20px;
      height: 20px;
      position: absolute;
      right: 10px;
      top: 10px;
      background-image: url(../../assets/common/close4.svg);
      background-size: 100% 100%;
      cursor: pointer;
      z-index: 2;
    }
    .close_btn:hover {
      opacity: 0.8;
      cursor: pointer;
    }
    .warn_icon {
      margin: 0 auto;
      margin-top: 35px;
      height: 58px;
      width: 58px;
      background-size: 100% 100%;
      background-image: url("../../assets/common/warn_icon.svg");
    }
    .warn_title {
      margin-top: 15px;
      font-weight: bolder;
      color: #1a1a1a;
      font-size: 17px;
      text-align: center;
    }
    .vip_tips {
      width: 294px;
      height: 20px;
      line-height: 20px;
      background-repeat: no-repeat;
      background-size: 100% auto;
      background-position: center center;
      text-align: center;
      font-size: 14px;
      font-weight: bolder;
      color: rgba(202, 135, 71, 1);
      margin: 0 auto;
      margin-top: 20px;
      margin-bottom: 20px;
    }
    .warn_tips {
      color: #999999;
      font-size: 12px;
      width: 250px;
      margin: 0 auto;
      margin-top: 15px;
      line-height: 20px;
      text-align: center;
      font {
        vertical-align: text-bottom;
      }
      span {
        vertical-align: text-bottom;
      }
      .vip {
        color: #daae84;
        margin-left: 2px;
        cursor: pointer;
      }
      .speed {
        color: #3a5bff;
        margin-left: 2px;
        margin-right: 2px;
        cursor: pointer;
      }
      .num {
        font-size: 16px;
        margin: 0 2px;
        font-weight: bolder;
      }
    }

    .btns {
      text-align: center;
      margin: 0 auto;
      margin-top: 15px;
    }

    .cancel_btn {
      display: inline-block;
      vertical-align: top;
      background-color: rgba(230, 230, 230, 1);
      color: rgba(153, 153, 153, 1);
      width: 133px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      margin-right: 20px;
      font-size: 14px;
      font-weight: bolder;
    }
    .cancel_btn:hover {
      opacity: 0.9;
      cursor: pointer;
    }

    .speed_btn {
      display: inline-block;
      vertical-align: top;
      background-color: rgba(31, 93, 227, 1);
      color: #ffffff;
      width: 133px;
      height: 40px;
      line-height: 40px;
      border-radius: 20px;
      margin-right: 20px;
      font-size: 14px;
      font-weight: bolder;
    }
    .speed_btn:hover {
      opacity: 0.9;
      cursor: pointer;
    }

    .pay_btn {
      display: inline-block;
      vertical-align: top;
      width: 133px;
      height: 40px;
      line-height: 40px;
      color: #5f4509;
      background: linear-gradient(
        140deg,
        #f2d7b3 4%,
        #e9c29b 57%,
        #d9ad84 100%
      );
      box-shadow: 0px 4px 12px 1px rgba(131, 106, 46, 0.16);
      border-radius: 58px 58px 58px 58px;
      opacity: 1;
      text-align: center;
      font-size: 14px;
      font-weight: bolder;
    }
    .pay_btn:hover {
      opacity: 0.9;
      cursor: pointer;
    }
  }

  .add-limit-wrap {
    padding-top: 1px;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 422px;
    height: 350px;
    border-radius: 8px;
    background: linear-gradient(180deg, #fceee3 0%, #ffffff 24%);
    box-shadow: 0px 8px 16px rgba(72, 68, 62, 0.4);
    border-radius: 8px;
    box-sizing: border-box;
    .limit-close {
      position: absolute;
      right: 0;
      top: 0;
      background-image: url("../../assets/remote/control6.svg");
      background-repeat: no-repeat;
      background-size: 100% 100%;
      width: 46px;
      height: 46px;
      cursor: pointer;
    }
    .limit-title {
      margin-top: 34px;
      font-weight: 600;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
      color: #1a1a1a;
    }
    .limit-text {
      margin-top: 4px;
      font-size: 12px;
      line-height: 18px;
      color: #c1c1c1;
      text-align: center;
      span {
        font-weight: 600;
        color: #ff4b4b;
      }
    }
    .limit-item {
      margin-top: 10px;
      text-align: center;
      .item-text {
        display: inline-block;
        vertical-align: top;
        font-weight: 600;
        font-size: 18px;
        line-height: 25px;
        color: #694516;
      }
      .item-text2 {
        margin-left: 24px;
      }
    }
    .limit-item2 {
      margin-top: 22px;
      margin-left: 160px;
      width: 198px;
      height: 138px;
      background-image: url("../../assets/device/limit1.png");
      background-repeat: no-repeat;
      background-size: 100% 100%;
    }
    .limit-item3 {
      position: absolute;
      top: 128px;
      left: 90px;
      font-weight: 600;
      font-size: 14px;
      line-height: 20px;
      color: #694516;
      .item3-text {
        margin-top: 12px;
        .item3-icon {
          display: inline-block;
          margin-right: 8px;
          vertical-align: top;
          background-image: url("../../assets/device/limit2.svg");
          background-repeat: no-repeat;
          background-size: 100% 100%;
          width: 16px;
          height: 17px;
        }
        .item3-icon2 {
          background-image: url("../../assets/device/limit3.svg");
        }
        .item3-icon3 {
          background-image: url("../../assets/device/limit4.svg");
        }
        .item3-icon4 {
          background-image: url("../../assets/device/limit5.svg");
        }
      }
    }
    .limit-btns {
      text-align: center;
      .btn {
        display: inline-block;
        vertical-align: top;
        width: 120px;
        height: 42px;
        line-height: 42px;
        background-color: #fff7f0;
        border: 1px solid #eee3d9;
        border-radius: 40px;
        font-size: 14px;
        color: #694516;
        box-sizing: border-box;
        cursor: pointer;
      }
      .btn2 {
        margin-left: 16px;
        border: none;
        background-image: linear-gradient(270deg, #724007 2%, #9f6f21 94%);
        font-weight: 600;
        font-size: 14px;
        color: #ffffff;
      }
    }
  }

  .speed_body {
    position: absolute;
    width: 409px;
    height: 141px;
    left: 50%;
    top: 350px;
    margin-left: -205px;
    background-image: url(../../assets/node/service/speed_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .speed_body_wrap {
      .mode_desc_item_wrap {
        margin-top: 32px;
        text-align: center;
        .mode_desc_item {
          display: inline-block;
          vertical-align: top;
          width: 120px;
          height: 70px;
          box-sizing: border-box;
          background-position: top center;
          background-repeat: no-repeat;
          background-size: 40px 40px;
          .mode_desc_item_text {
            text-align: center;
            font-size: 12px;
            color: #244ea7;
            margin-top: 50px;
            height: 20px;
            line-height: 20px;
            font {
              display: inline-block;
              vertical-align: text-bottom;
            }
            .num {
              font-weight: bolder;
              font-size: 16px;
              margin-right: 2px;
            }
          }
        }
        .mode_desc_item_01 {
          background-image: url("../../assets/speedShare/mode_desc_01.svg");
          border-right: 1px dashed #c8cddf;
        }
        .mode_desc_item_02 {
          background-image: url("../../assets/speedShare/mode_desc_03.svg");
          border-right: 1px dashed #c8cddf;
        }
        .mode_desc_item_03 {
          background-image: url("../../assets/speedShare/mode_desc_02.svg");
        }
      }
    }
  }

  .vip_body_wrap {
    .vip_item_wrap {
      width: 370px;
      height: 195px;
      margin: 0 auto;
      margin-top: 5px;
      border-radius: 5px;
      box-sizing: border-box;
      padding-top: 22px;
      text-align: center;
      .vip_item {
        width: 105px;
        height: 85px;
        display: inline-block;
        vertical-align: top;

        text-align: left;
        position: relative;
        box-sizing: border-box;
        .vip_item_title {
          font-size: 12px;
          color: rgba(227, 184, 148, 1);
          height: 20px;
          line-height: 20px;
          text-align: center;
        }
        .vip_item_value {
          color: rgba(95, 69, 9, 1);
          height: 20px;
          line-height: 20px;

          .vip_item_value_text {
            font-size: 12px;
            font-weight: bolder;
            text-align: center;
            font {
              vertical-align: text-bottom;
              font-size: 16px;
              font-weight: bolder;
              margin-right: 2px;
            }
          }
        }
        .vip_item_icon {
          width: 36px;
          height: 36px;
          background-size: 100% 100%;
          margin: 0 auto;
        }
      }
      .vip_item_01 {
        border-bottom: 1px dashed RGBA(225, 222, 217, 1);
        border-right: 1px dashed RGBA(225, 222, 217, 1);
        .vip_item_title {
        }
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_01.svg");
          bottom: 12px;
        }
      }
      .vip_item_02 {
        border-bottom: 1px dashed RGBA(225, 222, 217, 1);
        border-right: 1px dashed RGBA(225, 222, 217, 1);
        .vip_item_title {
        }
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_02.svg");
          bottom: 12px;
        }
      }
      .vip_item_03 {
        border-bottom: 1px dashed RGBA(225, 222, 217, 1);
        .vip_item_title {
        }
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_03.svg");
          bottom: 12px;
        }
      }
      .vip_item_04 {
        border-right: 1px dashed RGBA(225, 222, 217, 1);
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_04.svg");
          margin-top: 8px;
        }
        .vip_item_title {
        }
      }
      .vip_item_05 {
        border-right: 1px dashed RGBA(225, 222, 217, 1);
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_05.svg");
          margin-top: 8px;
        }
        .vip_item_title {
        }
      }
      .vip_item_06 {
        .vip_item_icon {
          background-image: url("../../assets/userinfo/vip_item_icon_06.svg");
          margin-top: 8px;
        }
        .vip_item_title {
        }
      }
    }
  }

  .vip_body {
    position: absolute;
    width: 410px;
    height: 247px;
    left: 50%;
    top: 350px;
    margin-left: -205px;
    background-image: url(../../assets/node/service/vip_bg.png);
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .vip_body_wrap {
      .vip_item_wrap {
        width: 370px;
        height: 195px;
        margin: 0 auto;
        margin-top: 12px;
        border-radius: 5px;
        box-sizing: border-box;
        padding-top: 22px;
        text-align: center;
        .vip_item {
          width: 115px;
          height: 85px;
          display: inline-block;
          vertical-align: top;

          text-align: left;
          position: relative;
          box-sizing: border-box;
          .vip_item_title {
            font-size: 12px;
            color: rgba(227, 184, 148, 1);
            height: 20px;
            line-height: 20px;
            text-align: center;
          }
          .vip_item_value {
            color: rgba(252, 237, 218, 1);
            height: 20px;
            line-height: 20px;

            .vip_item_value_text {
              font-size: 12px;
              font-weight: bolder;
              text-align: center;
              font {
                vertical-align: text-bottom;
                font-size: 16px;
                font-weight: bolder;
                margin-right: 2px;
              }
            }
          }
          .vip_item_icon {
            width: 36px;
            height: 36px;
            background-size: 100% 100%;
            margin: 0 auto;
          }
        }
        .vip_item_01 {
          border-bottom: 1px dashed RGBA(124, 107, 86, 1);
          border-right: 1px dashed RGBA(124, 107, 86, 1);
          .vip_item_title {
          }
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_01.svg");
            bottom: 12px;
          }
        }
        .vip_item_02 {
          border-bottom: 1px dashed RGBA(124, 107, 86, 1);
          border-right: 1px dashed RGBA(124, 107, 86, 1);
          .vip_item_title {
          }
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_02.svg");
            bottom: 12px;
          }
        }
        .vip_item_03 {
          border-bottom: 1px dashed RGBA(124, 107, 86, 1);
          .vip_item_title {
          }
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_03.svg");
            bottom: 12px;
          }
        }
        .vip_item_04 {
          border-right: 1px dashed RGBA(124, 107, 86, 1);
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_04.svg");
            margin-top: 8px;
          }
          .vip_item_title {
          }
        }
        .vip_item_05 {
          border-right: 1px dashed RGBA(124, 107, 86, 1);
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_05.svg");
            margin-top: 8px;
          }
          .vip_item_title {
          }
        }
        .vip_item_06 {
          .vip_item_icon {
            background-image: url("../../assets/userinfo/vip_item_icon_06.svg");
            margin-top: 8px;
          }
          .vip_item_title {
          }
        }
      }
    }
  }
}
</style>